<template>
  <dx-broker-offer-intro product="p-combi" />
</template>

<script>
import DxBrokerOfferIntro from '~/domains/brokerOffer/components/DX-BrokerOfferIntro'

export default {
  name: 'BrokerOfferPCombiIntro',
  components: {
    DxBrokerOfferIntro,
  },
  layout: 'non-sticky-nav',
  nuxtI18n: {
    paths: {
      de: '/partnerportal/privatrechtsschutz/p-kombi/antragsstrecke/',
      fr:
        '/portailpartenaires/protection-juridique-privee/p-combi/formulaire-de-demande/',
    },
  },
}
</script>
